import type { PropsWithChildren, ReactNode } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';
import { Placeholder } from './internals/placeholder';

export function ConditionsPlaceholder({ children }: PropsWithChildren): ReactNode {
  const { showPlaceholder } = usePlaceholders(PLACEHOLDERS.Conditions);

  if (showPlaceholder) {
    return (
      <div>
        <Placeholder width="100%" />
        <Placeholder width="220px" />
        <Placeholder width="552px" />
      </div>
    );
  }

  return <>{children}</>;
}
